import { Component, OnInit, ViewChild } from '@angular/core';
import { SharedService } from '../shared.service';
import { MessageService } from '../../core/services/message.service';
@Component( {
  selector: 'app-page-bottom',
  templateUrl: './page-bottom.component.html',
  styleUrls: [ './page-bottom.component.scss' ]
} )
export class PageBottomComponent implements OnInit {
  @ViewChild('content') content;
  @ViewChild('name') name;
  @ViewChild('email') email;
  @ViewChild('phone') phone;
  @ViewChild('qq') qq;

  public friendsShip: Array<Object>; //友情链接
  display: boolean = false;
  formData: any = {};
  constructor(
    private _sharedService: SharedService,
    private _msg: MessageService
  ) { }

  ngOnInit() {
    //友情链接
    this.friendshipLink();

  }

  friendshipLink() {
    this._sharedService.Friendship().then( resp => {
      if ( resp.success ) {
        this.friendsShip = resp[ 'data' ];
      }
    } );
  }


  //意见反馈弹出模态框
  adviceModal() {
    this.formData = {};
    this.display = true;

  }

  // 提交意见反馈
  saveadvice() {
    console.log(111);
    if ( !this.content.valid ) {
      this._msg.info( "请输入正确的反馈意见" );
      setTimeout(() => {
        this._msg.clear();
      }, 3000 ); return false;
    } else if ( !this.name.valid ) {
      this._msg.info( "请输入正确的姓名" );
      setTimeout(() => {
        this._msg.clear();
      }, 3000 ); return false;
    } else if ( !this.email.valid ) {
      this._msg.info( "请输入正确的邮箱" );
      setTimeout(() => {
        this._msg.clear();
      }, 3000 ); return false;
    } else if ( !this.phone.valid ) {
      this._msg.info( "请输入正确的手机号" );
      setTimeout(() => {
        this._msg.clear();
      }, 3000 ); return false;
    } else if ( !this.qq.valid ) {
      this._msg.info( "请输入正确的qq号" );
      setTimeout(() => {
        this._msg.clear();
      }, 3000 ); return false;
    } else {
     console.log(222);
      this._sharedService.getFeedback( this.formData ).then( data => {
        if ( data[ 'data' ][ 'success' ] ) {
          console.log(333);
          this.display = false;
          this._msg.success( data[ 'data' ][ 'message' ] );
          setTimeout(() => {
            this._msg.clear();
          }, 3000 );
        } else {
          console.log(444);
          this.display = false;
          this._msg.success( data[ 'data' ][ 'message' ] );
          setTimeout(() => {
            this._msg.clear();
          }, 3000 );
        }

      } );

    }






  }

}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/shared/page-bottom/page-bottom.component.ts